<script lang="ts" setup>
import SidePanelSectionItem from './SidePanelSectionItem.vue';
type Props = {
  text: string;
  tooltipText: string;
  icon?: any;
  showCheck?: boolean;
  loading?: boolean;
};

defineProps<Props>();

const emit = defineEmits(['click']);
</script>

<template>
  <v-list-item link rounded @click="emit('click')" height="40" width="100%" class="pa-0" :slim="true">
    <SidePanelSectionItem
      :text="text"
      :tooltipText="tooltipText"
      :icon="icon"
      :showCheck="showCheck"
      :loading="loading"
      :copyable="true"
    >
    </SidePanelSectionItem>
  </v-list-item>
</template>
